import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import * as runReducer from "containers/Run/reducer";
import * as viewReducer from "containers/View/reducer";
import * as createReducer from "containers/CreateWizard/reducer";
import * as setupReducer from "containers/Setup/reducer";
import * as globalReducer from "containers/App/reducer";
import * as oldProjectReducer from "containers/OldProject/reducer";
import * as modelGroupReducer from "containers/ModelGroup/reducer";

import RunRow from "components/View/Rows/RunRow";

import RunTile from "components/Tiles/RunTile";

import { isEnabled } from "utils/featureFlags";

class RunItemContainer extends React.Component {
  shouldComponentUpdate(nextProps) {
    const { isTile, type, data, isHighlight } = this.props;

    let shouldRender =
      isTile !== nextProps.isTile ||
      type !== nextProps.type ||
      data.id !== nextProps.data.id ||
      isHighlight !== nextProps.isHighlight ||
      data.status !== nextProps.data.status;

    if (data && data.transformedModels && nextProps && nextProps.data && nextProps.data.transformedModels) {
      if (data.transformedModels.length !== nextProps.data.transformedModels.length) {
        shouldRender = true;
      }
    }

    return shouldRender;
  }

  handleClick(data) {
    const { history, onClick, fetchRun, resetSearch } = this.props;

    const isAdvanced = isEnabled("aible-advanced");

    if (onClick !== undefined) {
      return onClick(data.id);
    } else if (isAdvanced) {
      resetSearch && resetSearch();
      return history.push("/project/" + data.id);
    }
    fetchRun();
    resetSearch && resetSearch();
    return history.push("run/" + data.id);
  }

  renderTile(data) {
    const { index, isHighlight, handleCancel, style, updateHoverRun, modelGroup, isFrontier, isMini, noDelete } =
      this.props;

    return (
      <div style={style} key={index}>
        {
          <RunTile
            run={data}
            handleCancel={() => handleCancel()}
            onHover={(id) => updateHoverRun(id)}
            onClick={() => this.handleClick(data)}
            isHighlight={isHighlight}
            isMini={isMini}
            modelGroup={modelGroup}
            isFrontier={isFrontier}
          />
        }
      </div>
    );
  }

  renderRow(data) {
    const { index, isHighlight, updateHoverRun } = this.props;
    return (
      <RunRow
        run={data}
        onHover={(id) => updateHoverRun(id)}
        onClick={() => this.handleClick(data)}
        key={index}
        isHighlight={isHighlight}
      />
    );
  }

  render() {
    const { isTile, isHighlight, fetchNext, isJobsLoading, data } = this.props;

    return isTile ? this.renderTile(data) : this.renderRow(data);
  }
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  updateDatasetId: (datasetId) => dispatch(setupReducer.updateDatasetId("new", datasetId)),

  updateProjectStep: (step) => dispatch(oldProjectReducer.updateStep(step)),
  updateLastRunId: (runId) => dispatch(oldProjectReducer.updateLastRunId(runId)),

  updateHoverRun: (id) => dispatch(globalReducer.updateHoverRun(id)),

  updateStep: (runId) => dispatch(createReducer.updateStep(runId)),

  handleCancel: () => dispatch(runReducer.cancelRun(ownProps.id)),
  fetchRun: () => dispatch(runReducer.fetchRun(ownProps.id)),

  resetSearch: () => dispatch(viewReducer.updateSearch(undefined))
});

const mapStateToProps = (state, ownProps) => {
  const job = runReducer.getTransformedJob(state, ownProps.id);
  const hoverItem = globalReducer.getHoverItem(state);

  return {
    data: job,
    isTile: ownProps.isTile ? ownProps.isTile : viewReducer.getIsTile(state),
    type: viewReducer.getType(state),
    isHighlight:
      hoverItem && job && job.setup
        ? hoverItem.id === job.setup.datasetId || (hoverItem.id === job.id && hoverItem.hoverType === "RUNID")
        : false,
    modelGroup: modelGroupReducer.getModelGroup(state, ownProps.id)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(RunItemContainer);
